/* Encabezado estilo Oner Active — oé / Chloé Active */
(function () {
  /* ---------- Mega menú de escritorio (hover) ---------- */
  function initMegaMenu(root) {
    var list = root.querySelector('.oe-nav__list');
    if (!list || list.dataset.oeReady) return;
    list.dataset.oeReady = 'true';
    var items = list.querySelectorAll('.oe-nav__item--has-mega');
    var openTimer = null;
    var closeTimer = null;

    function openItem(item) {
      items.forEach(function (other) {
        if (other !== item) closeItem(other);
      });
      item.classList.add('is-open');
      list.classList.add('has-open');
      var link = item.querySelector('.oe-nav__link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }
    function closeItem(item) {
      item.classList.remove('is-open');
      var link = item.querySelector('.oe-nav__link');
      if (link) link.setAttribute('aria-expanded', 'false');
      if (!list.querySelector('.oe-nav__item.is-open')) list.classList.remove('has-open');
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        var anyOpen = list.querySelector('.oe-nav__item.is-open');
        openTimer = setTimeout(function () { openItem(item); }, anyOpen ? 0 : 90);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { closeItem(item); }, 160);
      });
      /* En tablets (pantalla grande táctil): primer toque abre, segundo navega */
      var link = item.querySelector('.oe-nav__link');
      link.addEventListener('pointerup', function (e) {
        if (e.pointerType !== 'touch') return;
        if (!item.classList.contains('is-open')) {
          link.dataset.oeBlock = 'true';
          openItem(item);
        }
      });
      link.addEventListener('click', function (e) {
        if (link.dataset.oeBlock === 'true') {
          e.preventDefault();
          link.dataset.oeBlock = '';
        }
      });
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') items.forEach(closeItem);
    });
    document.addEventListener('pointerdown', function (e) {
      if (!root.contains(e.target)) items.forEach(closeItem);
    });
  }

  /* ---------- Menú del celular ---------- */
  class OeDrawer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.toggle = this.querySelector('.oe-drawer__toggle');
      this.panel = this.querySelector('.oe-drawer__panel');
      if (!this.toggle || !this.panel) return;

      /* El panel se mueve al <body> para que ningún contenedor lo recorte */
      document.body.appendChild(this.panel);
      this.overlay = document.createElement('div');
      this.overlay.className = 'oe-drawer-overlay';
      this.overlay.hidden = true;
      document.body.appendChild(this.overlay);

      this.toggle.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));
      this.overlay.addEventListener('click', () => this.close());
      this.panel.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') this.close();
      });

      /* Pestañas */
      this.tabs = Array.from(this.panel.querySelectorAll('.oe-drawer__tab'));
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.selectTab(tab)));

      /* Acordeones */
      this.panel.querySelectorAll('.oe-acc__button').forEach((button) => {
        button.addEventListener('click', () => {
          var content = document.getElementById(button.getAttribute('aria-controls'));
          var expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          if (content) content.hidden = expanded;
        });
      });

      window.addEventListener('resize', () => {
        if (this.isOpen) this.setTop();
        if (window.innerWidth >= 990 && this.isOpen) this.close();
      });
    }

    disconnectedCallback() {
      document.body.classList.remove('oe-drawer-open');
      if (this.panel && this.panel.parentNode) this.panel.remove();
      if (this.overlay && this.overlay.parentNode) this.overlay.remove();
    }

    setTop() {
      var header = document.querySelector('.section-header') || this.closest('.header-wrapper');
      var bottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      document.documentElement.style.setProperty('--oe-drawer-top', bottom + 'px');
    }

    selectTab(tab) {
      this.tabs.forEach((t) => {
        var selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      var scroll = this.panel.querySelector('.oe-drawer__scroll');
      if (scroll) scroll.scrollTop = 0;
    }

    open() {
      this.isOpen = true;
      this.setTop();
      this.panel.hidden = false;
      this.overlay.hidden = false;
      this.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('oe-drawer-open');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.panel.classList.add('is-open'));
      });
    }

    close() {
      this.isOpen = false;
      this.panel.classList.remove('is-open');
      this.overlay.hidden = true;
      this.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('oe-drawer-open');
      setTimeout(() => {
        if (!this.isOpen) this.panel.hidden = true;
      }, 300);
    }
  }
  if (!customElements.get('oe-drawer')) customElements.define('oe-drawer', OeDrawer);

  function init() {
    document.querySelectorAll('.oe-header').forEach(initMegaMenu);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Editor de temas: volver a iniciar cuando se recarga la sección */
  document.addEventListener('shopify:section:load', init);
})();
